// extracted by mini-css-extract-plugin
export default {"title":"jaIc45xLGT","items_list":"KhVZFmrfpk","items_grid":"flORzvEXyj","item":"_5E4sLPGO4"};